// ─── Centralise toutes les traductions d'enums ──────────────────────────────
// Utilisation :  import { alertTypeBadge, alertStatusBadge, ... } from '@/utils/labels'
// Chaque helper retourne { label, cls } pour l'affichage badge.

export const ALERT_TYPE = {
  photo_anomaly:        { label: 'Anomalie photo',      cls: 'badge-error'   },
  price_anomaly:        { label: 'Anomalie prix',       cls: 'badge-error'   },
  fake_cancellation:    { label: 'Fausse annulation',   cls: 'badge-pending' },
  proximity_no_mission: { label: 'Présence suspecte',   cls: 'badge-pending' },
  arrival_out_of_zone:  { label: 'Arrivée hors zone',   cls: 'badge-pending' },
}

export const ALERT_STATUS = {
  open:          { label: 'Ouverte',       cls: 'badge-error'   },
  investigating: { label: 'En enquête',    cls: 'badge-pending' },
  confirmed:     { label: 'Confirmée',      cls: 'badge-error'   },
  dismissed:     { label: 'Classée',        cls: 'badge-success' },
}

export const REASON_CODE = {
  verified_evidence:     'Preuves vérifiées',
  false_positive:        'Faux positif',
  insufficient_evidence: 'Preuves insuffisantes',
  policy_violation:      'Violation de politique',
}

export const SANCTION_STATE = {
  active:       { label: 'Actif',             cls: 'badge-success' },
  under_review: { label: 'Sous surveillance', cls: 'badge-warning' },
  suspended:    { label: 'Suspendu',          cls: 'badge-error'   },
}

export const APPROVAL_STATUS = {
  pending:   { label: 'En attente', cls: 'badge-pending' },
  approved:  { label: 'Approuvé',   cls: 'badge-success' },
  rejected:  { label: 'Rejeté',    cls: 'badge-error'   },
  suspended: { label: 'Suspendu',  cls: 'badge-warning' },
}

export const MISSION_STATUS = {
  PROPOSED:         { label: 'Proposition envoyée',   cls: 'badge-pending' },
  PENDING:          { label: 'En attente d’artisan',  cls: 'badge-pending' },
  PENDING_MATCHING: { label: 'Recherche d’artisan',   cls: 'badge-pending' },
  MATCHED:          { label: 'Artisan trouvé',        cls: 'badge-pending' },
  ACCEPTED:         { label: 'Mission acceptée',      cls: 'badge-pending' },
  ARTISAN_ACCEPTED: { label: 'Artisan en route',      cls: 'badge-pending' },
  EN_ROUTE:         { label: 'Artisan en route',      cls: 'badge-pending' },
  ARRIVED:          { label: 'Artisan sur place',     cls: 'badge-pending' },
  QUOTE_PENDING:    { label: 'En attente de devis',   cls: 'badge-pending' },
  QUOTE_READY:      { label: 'Devis proposé',         cls: 'badge-pending' },
  QUOTE_ACCEPTED:   { label: 'Devis accepté',         cls: 'badge-success' },
  WORKING:          { label: 'Intervention en cours', cls: 'badge-pending' },
  IN_PROGRESS:      { label: 'Intervention en cours', cls: 'badge-pending' },
  PENDING_CLOSURE:  { label: 'Attente validation PIN',cls: 'badge-warning' },
  WORK_SUBMITTED:   { label: 'Travaux terminés',      cls: 'badge-warning' },
  DONE:             { label: 'Mission terminée',      cls: 'badge-success' },
  COMPLETED:        { label: 'Mission terminée',      cls: 'badge-success' },
  CANCELLED:        { label: 'Mission annulée',       cls: 'badge-neutral' },
  DISPUTED:         { label: 'Litige en cours',       cls: 'badge-error'   },
}

export const ESCROW_HOLD_STATUS = {
  held:     { label: 'Séquestré (bloqué)',  cls: 'badge-warning' },
  released: { label: 'Versé à l’artisan',   cls: 'badge-success' },
  refunded: { label: 'Remboursé au client', cls: 'badge-neutral' },
}

export const ESCROW_HOLD_TYPE = {
  diagnostic: 'Garantie déplacement',
  quote:      'Devis prestation',
}

export const DISPUTE_STATUS = {
  open:         { label: 'Litige ouvert', cls: 'badge-error'   },
  in_review:    { label: 'En instruction',cls: 'badge-pending' },
  investigating:{ label: 'En enquête',    cls: 'badge-pending' },
  resolved:     { label: 'Litige résolu', cls: 'badge-success' },
  closed:       { label: 'Litige classé', cls: 'badge-neutral' },
}

// Helpers (retournent toujours un objet valide)
export const alertTypeBadge   = (v) => ALERT_TYPE[v]    || { label: v || '—', cls: 'badge-neutral' }
export const alertStatusBadge = (v) => ALERT_STATUS[v]  || { label: v || '—', cls: 'badge-neutral' }
export const sanctionBadge    = (v) => SANCTION_STATE[v]|| { label: v || '—', cls: 'badge-neutral' }
export const approvalBadge    = (v) => APPROVAL_STATUS[v]||{ label: v || '—', cls: 'badge-neutral' }
export const reasonLabel      = (v) => REASON_CODE[v]   || v || '—'

export const missionStatusBadge = (v) => MISSION_STATUS[v] || { label: v || '—', cls: 'badge-neutral' }
export const escrowHoldStatusBadge = (v) => ESCROW_HOLD_STATUS[v] || { label: v || '—', cls: 'badge-neutral' }
export const escrowHoldTypeLabel = (v) => ESCROW_HOLD_TYPE[v] || v || '—'
export const disputeStatusBadge = (v) => DISPUTE_STATUS[v?.toLowerCase()] || { label: v || '—', cls: 'badge-neutral' }

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('fr-FR', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  }) : '—'
